var _defs, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _text10, _text11, _text12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEsnadStructureAr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      background: "transparent",
      backgroundColor: "transparent",
      colorScheme: "light dark"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "792px",
    height: "242px",
    viewBox: "-0.5 -0.5 792 242",
    content: "<mxfile host=\"app.diagrams.net\" agent=\"Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/136.0.0.0 Safari/537.36\" version=\"27.0.2\" scale=\"1\" border=\"0\"> <diagram name=\"Seite-1\" id=\"A2zK-kq05AV7LeDPjtmd\"> <mxGraphModel dx=\"1234\" dy=\"790\" grid=\"1\" gridSize=\"10\" guides=\"1\" tooltips=\"1\" connect=\"1\" arrows=\"1\" fold=\"1\" page=\"1\" pageScale=\"1\" pageWidth=\"827\" pageHeight=\"1169\" background=\"none\" math=\"0\" shadow=\"0\"> <root> <mxCell id=\"0\" /> <mxCell id=\"1\" parent=\"0\" /> <mxCell id=\"bxYuBDioIangt8Z23EBY-6\" value=\"\" style=\"edgeStyle=orthogonalEdgeStyle;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;\" edge=\"1\" parent=\"1\" source=\"bxYuBDioIangt8Z23EBY-1\" target=\"bxYuBDioIangt8Z23EBY-3\"> <mxGeometry relative=\"1\" as=\"geometry\" /> </mxCell> <mxCell id=\"bxYuBDioIangt8Z23EBY-7\" style=\"edgeStyle=orthogonalEdgeStyle;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;entryX=0.5;entryY=0;entryDx=0;entryDy=0;\" edge=\"1\" parent=\"1\"> <mxGeometry relative=\"1\" as=\"geometry\"> <mxPoint x=\"420\" y=\"240\" as=\"sourcePoint\" /> <mxPoint x=\"660\" y=\"279\" as=\"targetPoint\" /> </mxGeometry> </mxCell> <mxCell id=\"bxYuBDioIangt8Z23EBY-1\" value=\"\\u0627\\u0644\\u0647\\u064A\\u0643\\u0644 \\u0627\\u0644\\u062A\\u0646\\u0638\\u064A\\u0645\\u064A\" style=\"rounded=1;whiteSpace=wrap;html=1;strokeWidth=2;fillColor=none;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"320\" y=\"160\" width=\"200\" height=\"40\" as=\"geometry\" /> </mxCell> <mxCell id=\"bxYuBDioIangt8Z23EBY-2\" value=\"\\u0627\\u0644\\u062C\\u0645\\u0639\\u064A\\u0629 \\u0627\\u0644\\u0639\\u0645\\u0648\\u0645\\u064A\\u0629\" style=\"rounded=1;whiteSpace=wrap;html=1;strokeWidth=2;fillColor=none;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"560\" y=\"280\" width=\"200\" height=\"40\" as=\"geometry\" /> </mxCell> <mxCell id=\"bxYuBDioIangt8Z23EBY-33\" style=\"edgeStyle=orthogonalEdgeStyle;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;entryX=0.5;entryY=0;entryDx=0;entryDy=0;\" edge=\"1\" parent=\"1\" source=\"bxYuBDioIangt8Z23EBY-3\" target=\"bxYuBDioIangt8Z23EBY-22\"> <mxGeometry relative=\"1\" as=\"geometry\" /> </mxCell> <mxCell id=\"bxYuBDioIangt8Z23EBY-34\" style=\"edgeStyle=orthogonalEdgeStyle;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;\" edge=\"1\" parent=\"1\" source=\"bxYuBDioIangt8Z23EBY-3\" target=\"bxYuBDioIangt8Z23EBY-21\"> <mxGeometry relative=\"1\" as=\"geometry\" /> </mxCell> <mxCell id=\"bxYuBDioIangt8Z23EBY-35\" style=\"edgeStyle=orthogonalEdgeStyle;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;entryX=0.5;entryY=0;entryDx=0;entryDy=0;\" edge=\"1\" parent=\"1\" source=\"bxYuBDioIangt8Z23EBY-3\" target=\"bxYuBDioIangt8Z23EBY-20\"> <mxGeometry relative=\"1\" as=\"geometry\"> <Array as=\"points\"> <mxPoint x=\"420\" y=\"340\" /> <mxPoint x=\"265\" y=\"340\" /> </Array> </mxGeometry> </mxCell> <mxCell id=\"bxYuBDioIangt8Z23EBY-36\" style=\"edgeStyle=orthogonalEdgeStyle;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;entryX=0.5;entryY=0;entryDx=0;entryDy=0;\" edge=\"1\" parent=\"1\" source=\"bxYuBDioIangt8Z23EBY-3\" target=\"bxYuBDioIangt8Z23EBY-19\"> <mxGeometry relative=\"1\" as=\"geometry\"> <Array as=\"points\"> <mxPoint x=\"420\" y=\"340\" /> <mxPoint x=\"165\" y=\"340\" /> </Array> </mxGeometry> </mxCell> <mxCell id=\"bxYuBDioIangt8Z23EBY-37\" style=\"edgeStyle=orthogonalEdgeStyle;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;entryX=0.5;entryY=0;entryDx=0;entryDy=0;\" edge=\"1\" parent=\"1\" source=\"bxYuBDioIangt8Z23EBY-3\" target=\"bxYuBDioIangt8Z23EBY-18\"> <mxGeometry relative=\"1\" as=\"geometry\"> <Array as=\"points\"> <mxPoint x=\"420\" y=\"340\" /> <mxPoint x=\"65\" y=\"340\" /> </Array> </mxGeometry> </mxCell> <mxCell id=\"bxYuBDioIangt8Z23EBY-38\" style=\"edgeStyle=orthogonalEdgeStyle;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;entryX=0.5;entryY=0;entryDx=0;entryDy=0;\" edge=\"1\" parent=\"1\" source=\"bxYuBDioIangt8Z23EBY-3\" target=\"bxYuBDioIangt8Z23EBY-23\"> <mxGeometry relative=\"1\" as=\"geometry\" /> </mxCell> <mxCell id=\"bxYuBDioIangt8Z23EBY-39\" style=\"edgeStyle=orthogonalEdgeStyle;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;entryX=0.5;entryY=0;entryDx=0;entryDy=0;\" edge=\"1\" parent=\"1\" source=\"bxYuBDioIangt8Z23EBY-3\" target=\"bxYuBDioIangt8Z23EBY-24\"> <mxGeometry relative=\"1\" as=\"geometry\"> <Array as=\"points\"> <mxPoint x=\"420\" y=\"340\" /> <mxPoint x=\"665\" y=\"340\" /> </Array> </mxGeometry> </mxCell> <mxCell id=\"bxYuBDioIangt8Z23EBY-40\" style=\"edgeStyle=orthogonalEdgeStyle;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;entryX=0.5;entryY=0;entryDx=0;entryDy=0;\" edge=\"1\" parent=\"1\" source=\"bxYuBDioIangt8Z23EBY-3\" target=\"bxYuBDioIangt8Z23EBY-13\"> <mxGeometry relative=\"1\" as=\"geometry\"> <Array as=\"points\"> <mxPoint x=\"420\" y=\"340\" /> <mxPoint x=\"765\" y=\"340\" /> </Array> </mxGeometry> </mxCell> <mxCell id=\"bxYuBDioIangt8Z23EBY-3\" value=\"\\u0645\\u062C\\u0644\\u0633 \\u0627\\u0644\\u0623\\u062F\\u0627\\u0631\\u0629\" style=\"rounded=1;whiteSpace=wrap;html=1;strokeWidth=2;fillColor=none;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"320\" y=\"280\" width=\"200\" height=\"40\" as=\"geometry\" /> </mxCell> <mxCell id=\"bxYuBDioIangt8Z23EBY-4\" value=\"\\u0627\\u0644\\u0647\\u064A\\u0626\\u0629 \\u0627\\u0644\\u0631\\u0642\\u0627\\u0628\\u064A\\u0629\" style=\"rounded=1;whiteSpace=wrap;html=1;strokeWidth=2;fillColor=none;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"80\" y=\"280\" width=\"200\" height=\"40\" as=\"geometry\" /> </mxCell> <mxCell id=\"bxYuBDioIangt8Z23EBY-5\" style=\"edgeStyle=orthogonalEdgeStyle;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;entryX=0.47;entryY=-0.05;entryDx=0;entryDy=0;entryPerimeter=0;\" edge=\"1\" parent=\"1\" source=\"bxYuBDioIangt8Z23EBY-1\" target=\"bxYuBDioIangt8Z23EBY-4\"> <mxGeometry relative=\"1\" as=\"geometry\"> <Array as=\"points\"> <mxPoint x=\"420\" y=\"240\" /> <mxPoint x=\"174\" y=\"240\" /> </Array> </mxGeometry> </mxCell> <mxCell id=\"bxYuBDioIangt8Z23EBY-13\" value=\"\\u0631\\u0626\\u064A\\u0633 \\u0627\\u0644\\u0645\\u0646\\u0638\\u0645\\u0629\" style=\"rounded=1;whiteSpace=wrap;html=1;strokeWidth=2;fillColor=none;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"720\" y=\"360\" width=\"90\" height=\"40\" as=\"geometry\" /> </mxCell> <mxCell id=\"bxYuBDioIangt8Z23EBY-18\" value=\"\\u0627\\u0644\\u0633\\u0643\\u0631\\u062A\\u0627\\u0631\\u064A\\u0629\" style=\"rounded=1;whiteSpace=wrap;html=1;strokeWidth=2;fillColor=none;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"20\" y=\"360\" width=\"90\" height=\"40\" as=\"geometry\" /> </mxCell> <mxCell id=\"bxYuBDioIangt8Z23EBY-19\" value=\"\\u0627\\u0644\\u0645\\u0633\\u0624\\u0648\\u0644 \\u0627\\u0644\\u0623\\u0639\\u0644\\u0627\\u0645\\u064A\" style=\"rounded=1;whiteSpace=wrap;html=1;strokeWidth=2;fillColor=none;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"120\" y=\"360\" width=\"90\" height=\"40\" as=\"geometry\" /> </mxCell> <mxCell id=\"bxYuBDioIangt8Z23EBY-20\" value=\"\\u0627\\u0644\\u0645\\u0633\\u0624\\u0648\\u0644 \\u0627\\u0644\\u0645\\u0627\\u0644\\u064A\" style=\"rounded=1;whiteSpace=wrap;html=1;strokeWidth=2;fillColor=none;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"220\" y=\"360\" width=\"90\" height=\"40\" as=\"geometry\" /> </mxCell> <mxCell id=\"bxYuBDioIangt8Z23EBY-21\" value=\"\\u0645\\u0633\\u0624\\u0648\\u0644 \\u0627\\u0644\\u0645\\u0634\\u0627\\u0631\\u064A\\u0639 \\u0627\\u0644\\u0645\\u0633\\u062A\\u062F\\u0627\\u0645\\u0629\" style=\"rounded=1;whiteSpace=wrap;html=1;strokeWidth=2;fillColor=none;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"320\" y=\"360\" width=\"90\" height=\"40\" as=\"geometry\" /> </mxCell> <mxCell id=\"bxYuBDioIangt8Z23EBY-22\" value=\"\\u0645\\u0633\\u0624\\u0648\\u0644 \\u0627\\u0644\\u0623\\u063A\\u0627\\u062B\\u0629\" style=\"rounded=1;whiteSpace=wrap;html=1;strokeWidth=2;fillColor=none;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"418\" y=\"360\" width=\"90\" height=\"40\" as=\"geometry\" /> </mxCell> <mxCell id=\"bxYuBDioIangt8Z23EBY-23\" value=\"\\u0627\\u0644\\u0646\\u0627\\u0626\\u0628 \\u0627\\u0644\\u062B\\u0627\\u0646\\u064A\" style=\"rounded=1;whiteSpace=wrap;html=1;strokeWidth=2;fillColor=none;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"520\" y=\"360\" width=\"90\" height=\"40\" as=\"geometry\" /> </mxCell> <mxCell id=\"bxYuBDioIangt8Z23EBY-24\" value=\"\\u0627\\u0644\\u0646\\u0627\\u0626\\u0628 \\u0627\\u0644\\u0623\\u0648\\u0644\" style=\"rounded=1;whiteSpace=wrap;html=1;strokeWidth=2;fillColor=none;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"620\" y=\"360\" width=\"90\" height=\"40\" as=\"geometry\" /> </mxCell> </root> </mxGraphModel> </diagram>\n</mxfile>\n",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": 0
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": 1
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "bxYuBDioIangt8Z23EBY-6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 401 41 L 401 114.63",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke",
    style: {
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 401 119.88 L 397.5 112.88 L 401 114.63 L 404.5 112.88 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "bxYuBDioIangt8Z23EBY-7"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 401 81 L 641.5 81.5 L 641.08 113.63",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke",
    style: {
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 641.01 118.88 L 637.61 111.84 L 641.08 113.63 L 644.61 111.93 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "bxYuBDioIangt8Z23EBY-1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 301,
    y: 1,
    width: 200,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    pointerEvents: "all",
    style: {
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 198,
      height: 1,
      paddingTop: 21,
      marginLeft: 302
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "\u0627\u0644\u0647\u064A\u0643\u0644 \u0627\u0644\u062A\u0646\u0638\u064A\u0645\u064A")))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 401,
    y: 25,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "\u0627\u0644\u0647\u064A\u0643\u0644 \u0627\u0644\u062A\u0646\u0638\u064A\u0645\u064A")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "bxYuBDioIangt8Z23EBY-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 541,
    y: 121,
    width: 200,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    pointerEvents: "all",
    style: {
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 198,
      height: 1,
      paddingTop: 141,
      marginLeft: 542
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "\u0627\u0644\u062C\u0645\u0639\u064A\u0629 \u0627\u0644\u0639\u0645\u0648\u0645\u064A\u0629")))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 641,
    y: 145,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "\u0627\u0644\u062C\u0645\u0639\u064A\u0629 \u0627\u0644\u0639\u0645\u0648\u0645\u064A\u0629")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "bxYuBDioIangt8Z23EBY-33"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 401 161 L 401 181 L 444 181 L 444 194.63",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke",
    style: {
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 444 199.88 L 440.5 192.88 L 444 194.63 L 447.5 192.88 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "bxYuBDioIangt8Z23EBY-34"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 401 161 L 401 181 L 346 181 L 346 194.63",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke",
    style: {
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 346 199.88 L 342.5 192.88 L 346 194.63 L 349.5 192.88 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "bxYuBDioIangt8Z23EBY-35"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 401 161 L 401 181 L 246 181 L 246 194.63",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke",
    style: {
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 246 199.88 L 242.5 192.88 L 246 194.63 L 249.5 192.88 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "bxYuBDioIangt8Z23EBY-36"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 401 161 L 401 181 L 146 181 L 146 194.63",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke",
    style: {
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 146 199.88 L 142.5 192.88 L 146 194.63 L 149.5 192.88 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "bxYuBDioIangt8Z23EBY-37"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 401 161 L 401 181 L 46 181 L 46 194.63",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke",
    style: {
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 46 199.88 L 42.5 192.88 L 46 194.63 L 49.5 192.88 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "bxYuBDioIangt8Z23EBY-38"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 401 161 L 401 181 L 546 181 L 546 194.63",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke",
    style: {
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 546 199.88 L 542.5 192.88 L 546 194.63 L 549.5 192.88 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "bxYuBDioIangt8Z23EBY-39"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 401 161 L 401 181 L 646 181 L 646 194.63",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke",
    style: {
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 646 199.88 L 642.5 192.88 L 646 194.63 L 649.5 192.88 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "bxYuBDioIangt8Z23EBY-40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 401 161 L 401 181 L 746 181 L 746 194.63",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke",
    style: {
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 746 199.88 L 742.5 192.88 L 746 194.63 L 749.5 192.88 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "bxYuBDioIangt8Z23EBY-3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 301,
    y: 121,
    width: 200,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    pointerEvents: "all",
    style: {
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 198,
      height: 1,
      paddingTop: 141,
      marginLeft: 302
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "\u0645\u062C\u0644\u0633 \u0627\u0644\u0623\u062F\u0627\u0631\u0629")))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 401,
    y: 145,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "\u0645\u062C\u0644\u0633 \u0627\u0644\u0623\u062F\u0627\u0631\u0629")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "bxYuBDioIangt8Z23EBY-4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 121,
    width: 200,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    pointerEvents: "all",
    style: {
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 198,
      height: 1,
      paddingTop: 141,
      marginLeft: 62
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "\u0627\u0644\u0647\u064A\u0626\u0629 \u0627\u0644\u0631\u0642\u0627\u0628\u064A\u0629")))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 161,
    y: 145,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "\u0627\u0644\u0647\u064A\u0626\u0629 \u0627\u0644\u0631\u0642\u0627\u0628\u064A\u0629")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "bxYuBDioIangt8Z23EBY-5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 401 41 L 401 81 L 155 81 L 155 112.63",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke",
    style: {
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 155 117.88 L 151.5 110.88 L 155 112.63 L 158.5 110.88 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "bxYuBDioIangt8Z23EBY-13"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 701,
    y: 201,
    width: 90,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    pointerEvents: "all",
    style: {
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 88,
      height: 1,
      paddingTop: 221,
      marginLeft: 702
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "\u0631\u0626\u064A\u0633 \u0627\u0644\u0645\u0646\u0638\u0645\u0629")))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 746,
    y: 225,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "\u0631\u0626\u064A\u0633 \u0627\u0644\u0645\u0646\u0638\u0645\u0629")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "bxYuBDioIangt8Z23EBY-18"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 201,
    width: 90,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    pointerEvents: "all",
    style: {
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 88,
      height: 1,
      paddingTop: 221,
      marginLeft: 2
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "\u0627\u0644\u0633\u0643\u0631\u062A\u0627\u0631\u064A\u0629")))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 46,
    y: 225,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "\u0627\u0644\u0633\u0643\u0631\u062A\u0627\u0631\u064A\u0629")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "bxYuBDioIangt8Z23EBY-19"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 201,
    width: 90,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    pointerEvents: "all",
    style: {
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 88,
      height: 1,
      paddingTop: 221,
      marginLeft: 102
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "\u0627\u0644\u0645\u0633\u0624\u0648\u0644 \u0627\u0644\u0623\u0639\u0644\u0627\u0645\u064A")))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 146,
    y: 225,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "\u0627\u0644\u0645\u0633\u0624\u0648\u0644 \u0627\u0644\u0623\u0639\u0644\u0627\u0645\u064A")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "bxYuBDioIangt8Z23EBY-20"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 201,
    y: 201,
    width: 90,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    pointerEvents: "all",
    style: {
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 88,
      height: 1,
      paddingTop: 221,
      marginLeft: 202
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "\u0627\u0644\u0645\u0633\u0624\u0648\u0644 \u0627\u0644\u0645\u0627\u0644\u064A")))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 246,
    y: 225,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "\u0627\u0644\u0645\u0633\u0624\u0648\u0644 \u0627\u0644\u0645\u0627\u0644\u064A")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "bxYuBDioIangt8Z23EBY-21"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 301,
    y: 201,
    width: 90,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    pointerEvents: "all",
    style: {
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 88,
      height: 1,
      paddingTop: 221,
      marginLeft: 302
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "\u0645\u0633\u0624\u0648\u0644 \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639 \u0627\u0644\u0645\u0633\u062A\u062F\u0627\u0645\u0629")))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 346,
    y: 225,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "\u0645\u0633\u0624\u0648\u0644 \u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639 \u0627\u0644\u0645\u0633\u062A\u062F\u0627\u0645\u0629")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "bxYuBDioIangt8Z23EBY-22"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 399,
    y: 201,
    width: 90,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    pointerEvents: "all",
    style: {
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 88,
      height: 1,
      paddingTop: 221,
      marginLeft: 400
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "\u0645\u0633\u0624\u0648\u0644 \u0627\u0644\u0623\u063A\u0627\u062B\u0629")))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 444,
    y: 225,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "\u0645\u0633\u0624\u0648\u0644 \u0627\u0644\u0623\u063A\u0627\u062B\u0629")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "bxYuBDioIangt8Z23EBY-23"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 501,
    y: 201,
    width: 90,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    pointerEvents: "all",
    style: {
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 88,
      height: 1,
      paddingTop: 221,
      marginLeft: 502
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "\u0627\u0644\u0646\u0627\u0626\u0628 \u0627\u0644\u062B\u0627\u0646\u064A")))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 546,
    y: 225,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "\u0627\u0644\u0646\u0627\u0626\u0628 \u0627\u0644\u062B\u0627\u0646\u064A")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "bxYuBDioIangt8Z23EBY-24"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 601,
    y: 201,
    width: 90,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    pointerEvents: "all",
    style: {
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 88,
      height: 1,
      paddingTop: 221,
      marginLeft: 602
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "\u0627\u0644\u0646\u0627\u0626\u0628 \u0627\u0644\u0623\u0648\u0644")))), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 646,
    y: 225,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "\u0627\u0644\u0646\u0627\u0626\u0628 \u0627\u0644\u0623\u0648\u0644"))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsnadStructureAr);
export default __webpack_public_path__ + "static/media/esnad-Structure-ar.5ccf0f5440845bffe34b20b7b5503a34.svg";
export { ForwardRef as ReactComponent };